import { ClientConfig } from './config/ClientConfig'
import { PokerMap } from './data/Map'
import { getLandingPage } from './PlatformUtils'
import { formatCurrency } from './number-format'
import { _siNumber } from './script-utils'

class OperatorConfig {

	public operatorId
	public currencyMap
	public populated
	public enabledCurrencies

	constructor() {
		this.operatorId = null
		this.currencyMap = new PokerMap<any>()
		this.populated = false
		this.enabledCurrencies = null
		this.populate()
	}

	isPopulated () {
		return this.populated
	}
	createCurrencyMap() {
		const sweeps = { code: 'XSD', name: 'Sweeps Coins', longName: 'Sweeps Coins', symbol: 'SC ', points: false }
		const gold = { code: 'XGC', name: 'Gold Coins', longName: 'Gold Coins', symbol: '', points: false }
		this.currencyMap.put(sweeps.code, sweeps)
		this.currencyMap.put(gold.code, gold)
	}

	isCurrencyEnabled(currencyCode : string) {
		return this.currencyMap.contains(currencyCode)
	}
	populate() {
		this.createCurrencyMap()
		this.populated = true
	}
	getLogoutUrl () {
		return getLandingPage()
	}
	getProfileLeaderboards () {
		return ClientConfig.PROFILE_LEADERBOARDS
	}
	getLobbyTopPromotionUrl () {
		return 'https://s3.amazonaws.com/global-poker-public/poker-client/top-promo/index.html?v=29'
	}
	getShareHandUrl () {
		return ClientConfig.SHARE_HAND_URL
	}

	/**
     * Returns the url for the buy credits page to be opened in an iframe.
     * If set to "internal" an internal page will be used.
     * If set to "event" nothing will be opened but the window message will be emitted.
     * See ToolbarManager.buyCredits() for more information.
     */
	getBuyCreditsUrl () {
		return 'event'
	}

	getEnabledCurrencies () {
		return this.currencyMap.values()
	}
	getCurrencyMap () {
		return this.currencyMap
	}
	isListAllEnabledCurrencies () {
		return false
	}

	getPersonalizedShareUrl(result) {
		const url = this.getShareHandUrl()
		return url.replace('{sharedHandId}',result.sharedHistoricHandId)
	}

	formatWithSymbol(amount: string | number, code: string, appendCurrencyName: boolean = false): string {
		const amountStr = '' + amount
		let result = amountStr + ' ' + code
		const currency = this.currencyMap.get(code)
		if (currency != null) {
			if (appendCurrencyName) {
				result = (currency.symbol != null && currency.symbol.length > 0 ? currency.symbol : '') + amountStr + ' ' + currency.name
			} else if (currency.symbol != null && currency.symbol.length > 0) {
				result = currency.symbol + amountStr
			} else {
				result = amountStr + ' ' + currency.name
			}
		}
		return result
	}

	formatCurrencyAmount(amount: string | number, code: string, includeCode = false): string {
		const formattedAmount = formatCurrency('' + amount)
		let result = `${formattedAmount} ${code}`
		const currency = this.currencyMap.get(code)
		if (currency != null) {
			if (currency.symbol != null && currency.symbol.length > 0) {
				result = currency.symbol + formattedAmount
			} else {
				result = formattedAmount
				if (includeCode === true) {
					result = `${result} ${currency.name}`
				}
			}
		}
		return result
	}

	formatMultipleAmounts(amount1: string | number, amount2: string | number, separator: string, code: string, includeCode?: boolean): string {
		if (typeof includeCode === 'undefined') {
			includeCode = false
		}
		const a1 = formatCurrency('' + amount1)
		const a2 = formatCurrency('' + amount2)
		let result = a1 + separator + a2 + ' ' + code
		const currency = this.currencyMap.get(code)
		if (currency != null) {
			if (currency.symbol != null && currency.symbol.length > 0) {
				result = currency.symbol + a1 + separator + currency.symbol + a2
			} else {
				result = a1 + separator + a2
				if (includeCode === true) {
					result = result + ' ' + currency.name
				}
			}
		}
		return result
	}

	formatMultipleAmountsShorthand(amount1: number, amount2: number, separator: string, code: string): string {
		const shortAmount1 = _siNumber(amount1, amount1 >= 100000 && amount1 < 1000000 ? 0 : 1)
		const shortAmount2 = _siNumber(amount2, amount2 >= 100000 && amount2 < 1000000 ? 0 : 1)
		if (shortAmount1 === 'NaN' || shortAmount2 === 'NaN') return ''
		const currency = this.currencyMap.get(code)
		if (currency && currency.symbol) {
			return currency.symbol + shortAmount1 + separator + currency.symbol + shortAmount2
		}
		return shortAmount1 + separator + shortAmount2
	}

	getCurrencySymbol(code: string): string {
		if (!code) {
			return ''
		}
		const currency = this.currencyMap.get(code)
		if (currency != null && currency.symbol != null && currency.symbol.length > 0) {
			return currency.symbol
		}
		return ''
	}
}
export const operatorConfig =  new OperatorConfig()
